import { isString } from 'lodash';
import PropTypes from 'prop-types';
// material
import { Box, Typography, Link, Stack } from '@mui/material';
//
import { MBreadcrumbs } from '../@mui-extend';

// ----------------------------------------------------------------------

HeaderBreadcrumbs.propTypes = {
  links: PropTypes.array,
  action: PropTypes.node,
  heading: PropTypes.string.isRequired,
  headingComponent: PropTypes.string,
  moreLink: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  sx: PropTypes.object
};

// `headingComponent` lets a route promote its page title to h1 while keeping the
// h4 styling; the tag and the visual variant are independent.
export default function HeaderBreadcrumbs({
  links,
  action,
  heading,
  headingComponent = 'h4',
  moreLink = '' || [],
  sx,
  ...other
}) {
  return (
    <Stack sx={sx} mb={5} spacing={2}>
      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography component={headingComponent} variant="h4" gutterBottom>
            {heading}
          </Typography>
          <MBreadcrumbs links={links} {...other} />
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Stack>

      {isString(moreLink) ? (
        <Link href={moreLink} target="_blank" variant="body2">
          {moreLink}
        </Link>
      ) : (
        moreLink.map((href) => (
          <Link noWrap key={href} href={href} variant="body2" target="_blank" sx={{ display: 'flex' }}>
            {href}
          </Link>
        ))
      )}
    </Stack>
  );
}
